export const BANK_TRANSACTIONS_TABLE_ID = "bt_table";
export const PURCHASE_INVOICES_TABLE_ID = "pi_table";
export const SALES_INVOICES_TABLE_ID = "si_table";
export const ACCOUNTING_DOCUMENTS_TABLE_ID = "accounting_documents_table";
export const TODOS_TABLE_ID = "coach-todos-table";
export const TODOS_MODAL_ID = "control-resolution-modal";

export const FLOWS_NAMINGS = {
  bankTransactions: "bt",
  purchaseInvoices: "pi",
  salesInvoices: "si",
};

export const FLOWS_TYPES = {
  bankTransaction: "bank_transaction",
  purchaseInvoice: "purchase",
  salesInvoice: "sales",
};

export const BANK_ACCOUNTS_TABS_NAMINGS = {
  statementBalances: "statement-balances-list",
  apiBalances: "api-balances-list",
  transactions: "transactions-list",
  disconnectedPeriods: "disconnected-periods-list",
  statements: "statements-list",
};

export const PURCHASE_INVOICE_PAID_BY_COMPANY = "paid_by_company";
